import React from 'react';
import {Row, Col, Label} from 'react-bootstrap';

class ProductDetail extends React.Component {

   /*****************************************/
   /* FUNCTION */
   /*****************************************/

   /*****************************************/
   /* EVENT */
   /*****************************************/

   /*****************************************/
   /* RENDER */
   /*****************************************/
   render() {

      return (

         <Col xs={12}>
            <div className="bloc-detail">
               <Row>
                  <Col xs={12} sm={6} md={4} lg={3}>
                     <h3>{this.props.infoDetail.nom}</h3>
                  </Col>
                  <Col xs={12} sm={6} md={8} lg={9}>
                     <h3>
                        {this.props.infoDetail.tag1 && <Label className="space" bsStyle="primary">tag 1</Label>}
                        {this.props.infoDetail.tag2 && <Label className="space" bsStyle="primary">tag 2</Label>}
                        {this.props.infoDetail.tag3 && <Label className="space" bsStyle="primary">tag 3</Label>}
                     </h3>
                  </Col>
               </Row>
               <Row>
                  <Col xs={12} sm={6} md={4} lg={3}>
                     <img className="width100" src={this.props.infoDetail.image} alt={this.props.infoDetail.nom} />
                  </Col>
                  <Col xs={12} sm={6} md={8} lg={9}>
                     <div>{this.props.infoDetail.description}</div>
                     <h5>Poids : {this.props.infoDetail.poids} Kg</h5>
                  </Col>
               </Row>
               <h3 className="prix">{this.props.infoDetail.prix} €</h3>
            </div>
         </Col>
         
      );
   }
}

export default ProductDetail;



// WEBPACK FOOTER //
// ./src/ProductDetail.js